module.exports = __webpack_public_path__ + "static/TNM079___Modeling_And_Animation__Lab_Report_Template-dbc2f4c60d74d9af83a644f088e303d2.pdf";